import { render } from "./AddAccountButton.vue?vue&type=template&id=b6cbd242&scoped=true"
import script from "./AddAccountButton.vue?vue&type=script&lang=js"
export * from "./AddAccountButton.vue?vue&type=script&lang=js"

import "./AddAccountButton.vue?vue&type=style&index=0&id=b6cbd242&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6cbd242"],['__file',"src/views/UserManagement/OrganizationManagement/components/OrganizationListComponents/AddAccountButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6cbd242"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6cbd242', __exports__)) {
    api.reload('b6cbd242', __exports__)
  }
  
  module.hot.accept("./AddAccountButton.vue?vue&type=template&id=b6cbd242&scoped=true", () => {
    api.rerender('b6cbd242', render)
  })

}


export default __exports__